// Web fallback using localStorage (MMKV is native-only)
const AsyncStorage = {
  getItem: (key) => Promise.resolve(localStorage.getItem(key)),

  setItem: (key, value) => {
    localStorage.setItem(key, value);
    return Promise.resolve();
  },

  removeItem: (key) => {
    localStorage.removeItem(key);
    return Promise.resolve();
  },

  multiSet: (pairs) => {
    pairs.forEach(([key, value]) => localStorage.setItem(key, value));
    return Promise.resolve();
  },

  multiRemove: (keys) => {
    keys.forEach((key) => localStorage.removeItem(key));
    return Promise.resolve();
  },

  getAllKeys: () => Promise.resolve(Object.keys(localStorage)),
};

export default AsyncStorage;
